export default "__VITE_ASSET__DZLdLuY$__"